import {useInfiniteQuery} from '@tanstack/react-query'
import {infiniteQueryFetchNextPage, QUERY_KEYS} from '@/queryClient'
import {httpGetUsers} from '@/features/users/services/users.http.ts'
import {HttpGetUsersParams, HttpGetUsersResponse} from '@/features/users/types.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {captureException} from '@sentry/react'

export const useGetUsers = (params: Omit<HttpGetUsersParams, 'page'>) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.USERS, params.searchString],
        queryFn: ({pageParam = 1}) =>
            parseAxiosPromise({
                axiosPromise: httpGetUsers({
                    ...params,
                    page: pageParam
                }),
                onZodError: captureException,
                responseShape: HttpGetUsersResponse
            }),
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.current_page < meta.last_page ? meta.current_page + 1 : null)
    })

    const remappedData = query.data?.pages[0]?.data?.length ? query.data.pages.flatMap(page => page.data) : []
    return {
        ...query,
        fetchNextPage: () => infiniteQueryFetchNextPage(query),
        remappedData
    }
}
